import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Fragment } from "react";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Avatar } from "../../../../../Avatar/index.js";
import { EllipsisText } from "../../../../../EllipsisText/index.js";
import { useStyles } from "./UserItem.styles.js";
const UserItem = (t0)=>{
    const $ = c(28);
    const { data, inputValue, handleSelectValue } = t0;
    const { classes } = useStyles();
    const { first_name: firstName, middle_name: middleName, second_name: secondName, logo, id, name } = data;
    const isUnit = !!name;
    const highlightLetters = _temp;
    let t1;
    if ($[0] !== handleSelectValue || $[1] !== id) {
        t1 = (itemName, type, itemLogo)=>{
            handleSelectValue({
                name: itemName,
                id,
                type,
                logo: itemLogo
            });
        };
        $[0] = handleSelectValue;
        $[1] = id;
        $[2] = t1;
    } else t1 = $[2];
    const onSelect = t1;
    let t2;
    if ($[3] !== firstName || $[4] !== isUnit || $[5] !== name || $[6] !== secondName) {
        t2 = ()=>isUnit ? `${null == name ? void 0 : name.charAt(0)}` : `${null == firstName ? void 0 : firstName.charAt(0)}${null == secondName ? void 0 : secondName.charAt(0)}`;
        $[3] = firstName;
        $[4] = isUnit;
        $[5] = name;
        $[6] = secondName;
        $[7] = t2;
    } else t2 = $[7];
    const stringAvatar = t2;
    let t3;
    if ($[8] !== firstName || $[9] !== isUnit || $[10] !== logo || $[11] !== middleName || $[12] !== name || $[13] !== onSelect || $[14] !== secondName) {
        t3 = (e)=>{
            e.preventDefault();
            onSelect(isUnit ? name : `${secondName} ${firstName} ${middleName}`, isUnit ? "unit" : "user", logo);
        };
        $[8] = firstName;
        $[9] = isUnit;
        $[10] = logo;
        $[11] = middleName;
        $[12] = name;
        $[13] = onSelect;
        $[14] = secondName;
        $[15] = t3;
    } else t3 = $[15];
    const t4 = classes.container;
    const t5 = stringAvatar();
    let t6;
    if ($[16] !== logo || $[17] !== t5) {
        t6 = /*#__PURE__*/ jsx(Avatar, {
            size: "extraSmall",
            src: logo,
            children: t5
        });
        $[16] = logo;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    const t7 = isUnit ? name : `${secondName} ${firstName} ${middleName}`;
    let t8;
    if ($[19] !== inputValue || $[20] !== t7) {
        t8 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            width: "calc(100% - 30px)",
            children: highlightLetters(t7, inputValue)
        });
        $[19] = inputValue;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== classes.container || $[23] !== id || $[24] !== t3 || $[25] !== t6 || $[26] !== t8) {
        t9 = /*#__PURE__*/ jsxs(Box, {
            px: "16",
            py: "12",
            display: "flex",
            alignItems: "center",
            gap: "8",
            id: id,
            cursor: "pointer",
            onMouseDown: t3,
            className: t4,
            children: [
                t6,
                t8
            ]
        });
        $[22] = classes.container;
        $[23] = id;
        $[24] = t3;
        $[25] = t6;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
function _temp(text, lettersToHighlight) {
    if (!lettersToHighlight.length) return /*#__PURE__*/ jsx(Typography, {
        variant: "body2",
        color: "text.light.primary",
        component: "span",
        noWrap: true,
        children: /*#__PURE__*/ jsx(EllipsisText, {
            wordBreak: "break-all",
            rows: 1,
            children: text
        })
    });
    const words = text.split(" ");
    const formattedWords = words.map((word)=>{
        const safeLetters = lettersToHighlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const partToHighlight = word.slice(0, lettersToHighlight.length).split(new RegExp(`(${safeLetters})`, "gi"));
        const restPart = word.slice(lettersToHighlight.length, word.length);
        return /*#__PURE__*/ jsx(Fragment, {
            children: [
                ...partToHighlight,
                restPart
            ].map((part, index, arr)=>{
                const currentPart = arr.length === index + 1 ? `${part}\xA0` : part;
                return part.toLowerCase() === lettersToHighlight.toLowerCase() ? /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    color: "text.light.primary",
                    component: "span",
                    noWrap: true,
                    children: currentPart
                }) : currentPart;
            })
        }, word);
    });
    return /*#__PURE__*/ jsx(Typography, {
        variant: "body2",
        color: "text.light.tertirary",
        component: "span",
        noWrap: true,
        children: /*#__PURE__*/ jsx(EllipsisText, {
            wordBreak: "break-all",
            rows: 1,
            children: formattedWords
        })
    });
}
export { UserItem };
